<template>
  <div class="mt-4">
    <template v-if="from.route">
      <add-place :place="place" />
    </template>
    <template v-else>
      <route-place :place="place" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddPlace from './AddPlace'
import RoutePlace from './RoutePlace'

export default {
  components: {
    AddPlace,
    RoutePlace
  },
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      from: 'map/getFrom',
    })
  }
}
</script>
